import { useMemo } from 'react';
import { Flex, Notice } from '@applyboard/crystal-ui';
import { DocumentReviewStatus } from '~/utils/languageProficiency';
interface LanguageProficiencyToastProps {
  documentReviewStatus: DocumentReviewStatus;
}

export function LanguageProficiencyToast({ documentReviewStatus }: LanguageProficiencyToastProps) {
  const getDocumentReviewStatus = useMemo(() => {
    switch (documentReviewStatus) {
      case 'VERIFIED':
        return (
          <Notice intent="positive" width="fill">
            These scores are directly from the source
          </Notice>
        );
      case 'UNABLE_TO_VERIFY':
        return (
          <Notice intent="primary" width="fill">
            Verification Services are unable to verify these scores.
          </Notice>
        );
      case 'NO_RECORD_FOUND':
        return (
          <Notice intent="negative" width="fill">
            No matching test record was found. Please verify the report ID and test details.
          </Notice>
        );
      case 'MANUALLY_ENTERED':
        return (
          <Notice intent="warning" width="fill">
            Manually provided by student
          </Notice>
        );
      case 'IDENTITY_MISMATCH':
        return (
          <Notice intent="warning" width="fill">
            The full name on the test record may not match the name on the application.
          </Notice>
        );
      default:
        return null;
    }
  }, [documentReviewStatus]);

  return (
    <Flex gap={6} direction="column">
      {getDocumentReviewStatus}
    </Flex>
  );
}
